import { render } from "./ProductFavoris.vue?vue&type=template&id=23d11860"
import script from "./ProductFavoris.vue?vue&type=script&lang=js"
export * from "./ProductFavoris.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__